import endOfMonth from 'date-fns/endOfMonth';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import { formatDate } from 'helpers/date';
import { isDateExpired } from 'v2/formatters/date';
import * as Yup from 'yup';

const lunhCheck = (cardNumber: string) => {
  if (cardNumber?.length === 0 || cardNumber?.length < 13 || cardNumber?.length > 19) {
    return false;
  }

  return (
    cardNumber
      ?.split('')
      .reverse()
      .map(x => parseInt(x, 10))
      .map((x, idx) => (idx % 2 ? x * 2 : x))
      .map(x => (x > 9 ? (x % 10) + 1 : x))
      .reduce((accum, x) => (accum += x)) %
      10 ===
    0
  );
};

const expiryDateIsValid = (monthYear: string) => {
  if (!monthYear || monthYear.length < 5) {
    return false;
  }

  const parsed = parse(monthYear, 'MM/yy', new Date());

  if (!isValid(parsed)) {
    return false;
  }

  const dateFormated = formatDate(endOfMonth(parsed), 'yyyy-MM-dd');

  const isExpired = isDateExpired(dateFormated);
  return !isExpired;
};

const CardSchema = Yup.object().shape({
  number: Yup.string()
    .required('O número do cartão é obrigatório')
    .test('invalid', 'O número do cartão é inválido', lunhCheck),
  name: Yup.string()
    .required('O nome impresso no cartão é obrigatório')
    .matches(/^[A-Z]/g, 'O nome precisa começar com ao menos uma letra'),
  expiry: Yup.string()
    .required('Data de expiração do cartão é obrigatório')
    .length(5, 'Data de expiração inválida')
    .test('invalid', 'Data de expiração informada está inválida', expiryDateIsValid),
  cvc: Yup.string()
    .required('O CVV do cartão é obrigatório')
    .matches(/^\d+$/, 'Campo aceita somente números')
    .min(3, 'O CVV do cartão deve conter pelo menos 3 digitos')
    .max(4, 'O CVV é inválido')
});

export default CardSchema;
